import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
export function OnboardingSuccess() {
  return <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-6" data-id="element-8796">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="max-w-2xl w-full" data-id="element-8797">
        <div className="bg-white rounded-2xl shadow-lg p-12 text-center" data-id="element-8798">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="inline-flex items-center justify-center w-24 h-24 bg-[#21A366] bg-opacity-10 rounded-full mb-6" data-id="element-8799">
            <CheckCircleIcon className="w-12 h-12 text-[#21A366]" data-id="element-8800" />
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-4xl font-bold text-[#132C53] mb-4" data-id="element-8801">
            Cont creat cu succes!
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-xl text-gray-600 mb-8" data-id="element-8802">
            Bine ai venit în ecosistemul CLC!
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-gradient-to-r from-[#357BEB] to-[#132C53] bg-opacity-10 rounded-xl p-6 mb-8" data-id="element-8803">
            <p className="text-gray-700 mb-4" data-id="element-8804">
              Contul tău a fost configurat complet. Acum poți accesa toate
              cursurile, instrumentele și resursele platformei.
            </p>
            <div className="flex items-center justify-center space-x-2 text-[#357BEB] font-semibold" data-id="element-8805">
              <span data-id="element-8806">Nivel actual:</span>
              <span className="bg-[#357BEB] text-white px-4 py-1 rounded-full text-sm" data-id="element-8807">
                Trainee
              </span>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="space-y-4" data-id="element-8808">
            <Link to="/profile" className="inline-flex items-center space-x-2 bg-[#357BEB] text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-[#2868d8] transition-all transform hover:scale-105 shadow-lg" data-id="element-8809">
              <span data-id="element-8810">Mergi la profil</span>
              <ArrowRightIcon className="w-5 h-5" data-id="element-8811" />
            </Link>
            <div className="flex items-center justify-center space-x-4 text-sm" data-id="element-8812">
              <Link to="/cursuri" className="text-[#357BEB] hover:underline font-semibold" data-id="element-8813">
                Explorează cursurile
              </Link>
              <span className="text-gray-400" data-id="element-8814">•</span>
              <Link to="/" className="text-[#357BEB] hover:underline font-semibold" data-id="element-8815">
                Înapoi la acasă
              </Link>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>;
}